import styled from "styled-components";

export const Container = styled.div`
  align-self: center;
  margin: 1.5rem;
  cursor: pointer;
`;

export const ImageContainer = styled.img`
  width: auto;
  height: 20rem;
  border-radius: 0;
  align-self: center;
  object-fit: cover;
`;
